import LayoutActividad from "../../../components/LayoutActividad";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo5 } from "../../../routes/Module5";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import Modulo5Act4 from "../../../DnD/modulo5Act4";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo5/Actividad 4.mp3";

const Actividad4 = () => {
  const infoUnidad = modulo5.content[0];
  const infoAct = modulo5.content[0].activities[3];
  const crumbs = [
    {
      title: modulo5.title,
      url: "/" + modulo5.url,
    },
    {
      title:
        modulo5.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo5.content[0].activities[4].name}`,
    linkNext: `${modulo5.url}/${modulo5.content[0].path}/${modulo5.content[0].activities[4].path}`,
    titlePrev: `${modulo5.content[0].activities[2].name}`,
    linkPrev: `${modulo5.url}/${modulo5.content[0].path}/${modulo5.content[0].activities[2].path}`,
  };

  const metadata = {
    color: modulo5.color,
    title: `${modulo5.title} - ${infoAct.name}`,
    name: modulo5.title,
  };
  const items = [
    <div className="selectable btn btn-blue shadow mx-3 my-1">identidad</div>,
    <div className="selectable btn btn-blue shadow mx-3 my-1">comunidad</div>,
    <div className="selectable btn btn-blue shadow mx-3 my-1">documento</div>,
  ];
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo5.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
      <AudioPlayer track={Audio} />

      <ul className="mb-5">
        <li>
          ¿Qué crees que significan estas palabras? Coloca cada palabra arriba
          de la imagen que mejor la represente.
        </li>
      </ul>

      <Modulo5Act4 items={items} />

      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen las imágenes y ayude a identificar a
          qué palabra corresponde cada una.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad4;
